export default {"src":"/_next/static/media/bw.88e1b387.svg","height":32,"width":172,"blurWidth":0,"blurHeight":0};